import { Box, withStyles, capitalizeFirstLetter, getCSSVariable } from 'vopay';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TabButton from '../../components/TabButton';
import styles from './AccountLimits.module.scss';
import { Title } from 'UI';
import AccountLimit from './AccountLimit';
import Throbber from '../../components/Throbber';
import { AccountLimits as AccountLimitsType } from '@/hooks/useApi/useFetchAccountLimits';

const cn = withStyles(styles);

type AccountLimitsProps = {
  accountLimits: AccountLimitsType | null;
  currency: string;
  loading: boolean;
};

type Tab = 'daily' | 'weekly' | 'monthly';

export default function AccountLimits({ accountLimits, currency, loading }: AccountLimitsProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'HomepageRevamp.Widgets.AccountLimits' });
  const [activeTab, setActiveTab] = useState<Tab>('daily');
  const limitType = capitalizeFirstLetter(activeTab) as 'Daily' | 'Weekly' | 'Monthly';
  const primaryColor = getCSSVariable('--primaryColor');

  const options: { label: string; value: Tab }[] = [
    { label: t('daily'), value: 'daily' },
    { label: t('weekly'), value: 'weekly' },
    { label: t('monthly'), value: 'monthly' },
  ];

  const parseAmount = (value: string | undefined | null): string => {
    const num = Number(value);
    return isNaN(num) ? '0.00' : String(num);
  };

  return (
    <>
      <Box ai="center" jc="sb" mb="md" height="auto">
        <Title level="5">{t('title')}</Title>
        <TabButton disabled={loading} options={options} value={activeTab} onSelect={setActiveTab} />
      </Box>
      <div className={cn('accountLimitsContainer')}>
        {loading ? (
          <div
            style={{
              position: 'absolute',
              inset: 0,
              display: 'grid',
              placeItems: 'center',
            }}
          >
            <Throbber />
          </div>
        ) : accountLimits ? (
          <>
            <AccountLimit
              type="Inbound"
              title={t('fundLimit')}
              remainingAmount={t('remainingAmount')}
              startingAmount={t('startingAmount')}
              remaining={parseAmount(accountLimits.Inbound.RemainingLimits[limitType])}
              total={parseAmount(accountLimits.Inbound.Limits[limitType])}
              currency={currency}
              primaryColor={primaryColor}
            />

            <AccountLimit
              type="Outbound"
              title={t('withdrawLimit')}
              remainingAmount={t('remainingAmount')}
              startingAmount={t('startingAmount')}
              remaining={parseAmount(accountLimits.Outbound.RemainingLimits[limitType])}
              total={parseAmount(accountLimits.Outbound.Limits[limitType])}
              currency={currency}
              primaryColor={primaryColor}
            />
          </>
        ) : null}
      </div>
    </>
  );
}
